import { render, staticRenderFns } from "./ExtratoCda.vue?vue&type=template&id=e35cb312&scoped=true&"
import script from "./ExtratoCda.vue?vue&type=script&lang=js&"
export * from "./ExtratoCda.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoCda.vue?vue&type=style&index=0&id=e35cb312&scoped=true&lang=css&"
import style1 from "./ExtratoCda.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35cb312",
  null
  
)

export default component.exports